import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}

img{
  max-height: 100px;
  max-width: 100px;
}
`